import { defineComponent, onMounted, reactive, ref, toRefs } from "vue";
export default defineComponent({
  name: "Ai-Dot",
  inheritAttrs: true,
  props: {
    target: String
  },
  setup(props) {
    const refTarget = ref(null);
    const dotsStr = localStorage.getItem("dots");
    const dots = ref({
      canvas: false,
      square: false,
      changeMode: false,
      upgrade: false,
      invite: false
    });
    try {
      if (dotsStr) dots.value = JSON.parse(dotsStr);
      console.log(JSON.parse(dotsStr));
    } catch (e) {
      console.log(e);
    }
    function click() {
      dots.value[props.target] = true;
      localStorage.setItem("dots", JSON.stringify(dots.value));
    }
    onMounted(() => {
      if (refTarget.value) {
        refTarget.value.parentElement.onclick = click;
      }
    });
    return {
      click,
      refTarget,
      dots
    };
  }
});